import { Pipe, PipeTransform } from '@angular/core';
import { UserTypeEnum } from '@shared/model/enum/user-type-enum';
import { FollowStateEnum } from '@shared/model/enum/follow-state-enum';
import { CustomerModel, activeUserModel } from '@shared/model/customerModels/customer-model';
import { PublisherModel } from '@app/pages/publisher/models/publisher-model';
import { ActivitiesActorAndAffected } from '@shared/model/activities-aggrigator-model';
import { ISearchedProfileResult } from '@app/pages/search/models/searched-profile-result.interface';
import { LikeAggrigatorModel } from '@shared/model/Activity_Aggtigator/like-aggrigator-model';

@Pipe({
  name: 'followUserData',
  standalone: true
})
export class FollowUserDataPipe implements PipeTransform {

  transform(user: CustomerModel | PublisherModel | ActivitiesActorAndAffected | ISearchedProfileResult | LikeAggrigatorModel | any, followState?: FollowStateEnum): IFollowStateData {
    const isPublisher = Object.getOwnPropertyNames(user!)?.find(x => x?.match("title"));
    const authorWithType = Object.getOwnPropertyNames(user!).find(x => x.match("myFollowStateWith"));
    const userWithType = Object.getOwnPropertyNames(user!).find(x => x.match("myFollowState"));
    const withType = Object.getOwnPropertyNames(user!).find(x => x.match("type"));
    const searchResult = Object.getOwnPropertyNames(user!).find(x => x.match("followState")); 1
    let userData: IFollowStateData;
    if (isPublisher) {
      const transferdUser = user as PublisherModel;
      userData = {
        id: transferdUser?.id!,
        name: transferdUser?.title!,
        followState: transferdUser?.myFollowState!,
        userType: UserTypeEnum.Publisher,
        buttonClass: this.getButtonClass(followState!),
        followStateText: this.getFollowStateText(transferdUser?.myFollowState!)
      }
    }
    else if (authorWithType) {
      const transferdUser = user as activeUserModel;
      userData = {
        id: transferdUser?.id! || transferdUser?.objectId!,
        userName: transferdUser?.userName,
        name: transferdUser?.fullName!,
        userType: user?.userIsAuthor ? UserTypeEnum.Author : UserTypeEnum.User,
        buttonClass: this.getButtonClass(transferdUser?.myFollowStateWith!),
        followState: transferdUser?.myFollowStateWith!,
        followStateText: this.getFollowStateText(transferdUser?.myFollowStateWith!)
      }
    }
    else if (userWithType) {
      let userType = null;
      if (user.isAuthorConnected! || !user?.userIsAuthor) {
        userType = UserTypeEnum.User;
      }
      else {
        userType = UserTypeEnum.Author;
      }
      const transferdUser = user as activeUserModel;
      userData = {
        id: transferdUser?.id || transferdUser?.objectId!,
        userName: transferdUser?.userName || transferdUser?.uniqeName,
        name: transferdUser?.fullName!,
        userType,
        buttonClass: this.getButtonClass(transferdUser?.myFollowStateWith!),
        followState: transferdUser?.myFollowState!,
        followStateText: this.getFollowStateText(transferdUser?.myFollowState!)
      }
    }
    else if (withType) {
      const transferdUser = user as ActivitiesActorAndAffected;
      userData = {
        id: transferdUser?.id!,
        userName: transferdUser?.userName,
        name: transferdUser?.fullName!,
        userType: user?.userIsAuthor ? UserTypeEnum.Author : transferdUser?.type!,
        buttonClass: this.getButtonClass(transferdUser?.myFollowState!),
        followState: transferdUser?.myFollowState!,
        followStateText: this.getFollowStateText(transferdUser?.myFollowState!)
      }
    }
    else if (searchResult) {
      const transferdUser = user as ISearchedProfileResult;
      userData = {
        id: transferdUser?.id!,
        userName: transferdUser?.username,
        name: transferdUser?.name!,
        userType: transferdUser?.profileType!,
        buttonClass: this.getButtonClass(transferdUser?.followState!),
        followState: transferdUser?.followState!,
        followStateText: this.getFollowStateText(transferdUser?.followState!)
      }
    }
    else {
      const transferdUser = user as CustomerModel;
      userData = {
        id: transferdUser?.id!,
        userName: transferdUser?.uniqeName,
        name: transferdUser?.firstName!,
        userType: 1,
        buttonClass: this.getButtonClass(transferdUser?.myFollowState!),
        followState: transferdUser?.myFollowState!,
        followStateText: this.getFollowStateText(transferdUser?.myFollowState!)
      }
    }
    return userData;
  }

  getFollowStateText(followState: FollowStateEnum): string {
    return (followState === FollowStateEnum.NoThing || followState === FollowStateEnum.NotFollowed || followState === FollowStateEnum.OneWayThem || !followState) ? 'دنبال کردن' :
      (followState === FollowStateEnum.OneWayYou || followState === FollowStateEnum.TwoWay) ? 'دنبال شده' :
        'در انتظار تایید'
  }

  getButtonClass(followState: FollowStateEnum): string {
    return (followState === FollowStateEnum.NoThing || followState === FollowStateEnum.NotFollowed || followState === FollowStateEnum.OneWayThem) ? 'btn-sm-a-fill' :
      (followState === FollowStateEnum.OneWayYou || followState === FollowStateEnum.TwoWay) ? 'btn-sm-a-overlay' :
        'btn-sm-a-outline'
  }
}

export interface IFollowStateData {
  id: string;
  name: string;
  userName?: string;
  buttonClass: string;
  followStateText: string;
  followState: FollowStateEnum;
  userType: UserTypeEnum;
  followBack?: boolean;
}
